import { memo, type CSSProperties, type ReactNode } from "react";
import Slider from "react-slick";
import { HERO_SETTINGS } from "../../constants/sliderSettings";

// import hat from "../../Assets/Images/hat.webp";
// import apple from "../../Assets/Images/apple.webp";
// import pen from "../../Assets/Images/pen.webp";
// import triangle from "../../Assets/Images/triangle.webp";
// import aeroplane from "../../Assets/Images/aero-plane.webp";
// import quran from "../../Assets/Images/quran.webp";
import playIcon from "../../Assets/Images/playstore Icon.webp";
import bannerThirdImage from "../../Assets/Images/Banner-third-image.webp";
import banner_image1 from "../../Assets/Images/4img.webp";
import banner_image3 from "../../Assets/Images/B3.webp";
import banner_image4 from "../../Assets/Images/B4.webp";
import banner_image5 from "../../Assets/Images/banner-fourth-img.png";
import banner_image6 from "../../Assets/Images/B6.webp";
import timingImage from "../../Assets/Images/GrouptimePrho.png";

const RED = "#9C050C";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.jazzeducator&hl=en&gl=US";

/* -------------------------------------------------------------------------- */
/* Decorative floating art objects                                            */
/* -------------------------------------------------------------------------- */

// interface ArtObjectConfig {
//   wrapperClassName: string;
//   imgClassName: string;
//   src: string;
// }

/** Typed identity helper: validates each value while preserving literal keys. */
// const asArtObjects = <T extends Record<string, ArtObjectConfig>>(config: T): T =>
  // config;

// const ART_OBJECTS = asArtObjects({
//   hat: { wrapperClassName: "art-obj hat-postion", imgClassName: "hatImg", src: hat },
//   apple: { wrapperClassName: "art-obj apple-position", imgClassName: "appleImg", src: apple },
//   pen: { wrapperClassName: "art-obj pen-position", imgClassName: "penImg", src: pen },
//   triangle: { wrapperClassName: "art-obj triangle-position", imgClassName: "triangleImg", src: triangle },
//   aeroplane: { wrapperClassName: "art-obj aeroplane-position", imgClassName: "aeroplaneImg", src: aeroplane },
//   quran: { wrapperClassName: "art-obj quran-position", imgClassName: "quran-Img", src: quran },
// });

// type ArtKey = keyof typeof ART_OBJECTS;s

// const STANDARD_ART: ArtKey[] = ["hat", "apple", "pen", "triangle", "aeroplane"];
// const QURAN_ART: ArtKey[] = ["hat", "apple", "pen", "triangle", "quran"];

// const ArtObject = ({ artKey }: { artKey: ArtKey }) => {
//   const { wrapperClassName, imgClassName, src } = ART_OBJECTS[artKey];
//   return (
//     <div className={wrapperClassName}>
//       <img src={src} className={imgClassName} alt="" />
//     </div>
//   );
// };

/* -------------------------------------------------------------------------- */
/* Play-store download button (desktop / mobile variants)                     */
/* -------------------------------------------------------------------------- */

// const DownloadButton = ({ variant }: { variant: "desktop" | "mobile" }) => {
//   const isMobile = variant === "mobile";
//   return (
//     <a href={PLAY_STORE_URL}>
//       <div
//         className={`d-flex ${isMobile ? "mobileDownloadContainer" : "downloadContainer"}`}
//         style={{ marginTop: isMobile ? "2%" : "6%" }}
//       >
//         <div className={isMobile ? "download_NowMobile" : "download_Now"}>
//           <span className="downloadNowText">DOWNLOAD NOW</span>
//         </div>
//         <div className={isMobile ? "playIcon_divMobile" : "playIcon_div"}>
//           <img src={playIcon} className="playButtonIcon" alt="Google Play" />
//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <span className="playButtonText1">GET IT ON</span>
//             <span className="playButtonText2">Google Play</span>
//           </div>
//         </div>
//       </div>
//     </a>
//   );
// };

/* -------------------------------------------------------------------------- */
/* Hero panels                                                                */
/* -------------------------------------------------------------------------- */

interface HeroPanel {
  id: string;
  heading: ReactNode;
  headingClassName: string;
  description: string;
  image: string;
  imageClassName: string;
  imageStyle?: CSSProperties;
  // art: ArtKey[];
  showDots: boolean;
}

const HERO_PANELS: HeroPanel[] = [
  {
    id: "knowledge",
    headingClassName: "banner-headingText",
    heading: (
      <>
        <span style={{ color: "#191919" }}>Knowledge</span> on the Go!
        <br />
        Play and<span style={{ color: "#191919" }}> Earn Points</span>
      </>
    ),
    description:
      "Put your knowledge to the test and win BIG! Participate in our exciting quiz challenge. Climb the leaderboard for glory. Score BIG and win 3GB of FREE data!",
    image: bannerThirdImage,
    imageClassName: "banner-img2",
    // art: STANDARD_ART,
    showDots: true,
  },
  // {
  //   id: "sat",
  //   headingClassName: "banner-headingText bld cntr",
  //   heading: (
  //     <>
  //       <span style={{ color: RED, fontWeight: "bold" }}>Unlock </span> Your
  //       Potential
  //       <br />
  //       <span style={{ fontWeight: "bold" }}>With Our </span>
  //       <span style={{ color: RED, fontWeight: "bold" }}>SAT Course! </span>
  //     </>
  //   ),
  //   description:
  //     "Embark on your path to SAT success with our comprehensive course. Our SAT course will equip you with the skills and confidence needed to excel on test day. Start your journey toward achieving your academic and career aspirations.",
  //   image: banner_image5,
  //   imageClassName: "banner-img2",
  //   // art: STANDARD_ART,
  //   showDots: false,
  // },
  // {
  //   id: "quran",
  //   headingClassName: "banner-headingText",
  //   heading: (
  //     <>
  //       <span style={{ color: RED }}>Live</span> Quran
  //       <span style={{ color: RED }}> Class</span>
  //       <br />
  //       <div className="timingImageContainer">
  //         <img src={timingImage} className="timmingImage" alt="Class timings" />
  //       </div>
  //     </>
  //   ),
  //   description:
  //     "Learn Live Quran with tajweed, Reciting without Tajweed could change the meaning of words.",
  //   image: banner_image6,
  //   imageClassName: "banner-img6",
  //   imageStyle: { width: "32%" },
  //   // art: QURAN_ART,
  //   showDots: true,
  // },
  // {
  //   id: "free-learning",
  //   headingClassName: "banner-headingText",
  //   heading: (
  //     <>
  //       <span style={{ color: RED }}> Unlock</span> The Ultimate
  //       <br />
  //       Level Of<span style={{ color: RED }}> Free Learning</span>
  //     </>
  //   ),
  //   description:
  //     "We aim to provide you with the best material for your academic learning and broaden your horizons for all the subjects so you can do best in your className and your life",
  //   image: banner_image1,
  //   imageClassName: "banner-img1",
  //   // art: [],
  //   showDots: true,
  // },
  // {
  //   id: "ad-free",
  //   headingClassName: "banner-headingText",
  //   heading: (
  //     <>
  //       <span style={{ color: RED }}>Enjoy </span>Ad
  //       <span style={{ color: RED }}> FREE Video</span>
  //       <br />
  //       <span style={{ color: RED }}> Lectures</span>
  //       <span> On The Go!</span>
  //     </>
  //   ),
  //   description:
  //     "We aim to provide you with the best matterial for your academic learning and braoden your horizens for all the subjects so you can do best in your className and your life",
  //   image: banner_image3,
  //   imageClassName: "banner-img2",
  //   // art: STANDARD_ART,
  //   showDots: false,
  // },
  // {
  //   id: "language",
  //   headingClassName: "banner-headingText",
  //   heading: (
  //     <>
  //       <span style={{ color: RED }}> Speak</span> A New{" "}
  //       <span style={{ color: RED }}>Language</span>
  //       <br />
  //       With <span style={{ color: RED }}> Confidence</span>
  //     </>
  //   ),
  //   description:
  //     "Everyone can learn a new language with Sekho using our free mobile App and a few minutes per day. Learn English and 10+ languages online with bite-sized lessons",
  //   image: banner_image4,
  //   imageClassName: "banner-img2",
  //   // art: STANDARD_ART,
  //   showDots: false,
  // },
];

const HeroPanelView = ({ panel }: { panel: HeroPanel }) => (
  <div className="hero-panel">
    {/* {panel.art.map((artKey) => (
      <ArtObject key={artKey} artKey={artKey} />
    ))} */}
    <div className="hero-slider">
      <div className="container p-0 containerMargin">
        <div className="row rowMarginLeft">
          <div className="col-lg-6 col-md-6 col-xl-6 col-sm-12 col-12">
            <div>
              <h1 className={panel.headingClassName}>{panel.heading}</h1>
              <div className="banner-desc">
                <span className="banner-descText">{panel.description}</span>
              </div>
            </div>
            {/* <DownloadButton variant="desktop" /> */}
          </div>
          <div className="col-lg-6 col-md-6 col-xl-6 col-sm-12 col-12 bannerImagContainer">
            <img
              src={panel.image}
              className={panel.imageClassName}
              style={panel.imageStyle}
              alt=""
            />
            {/* <DownloadButton variant="mobile" /> */}
          </div>
        </div>
      </div>
      {panel.showDots && <div className="slick-dots" />}
    </div>
  </div>
);

const HeroCarousel = () => (
  <div>
    <Slider {...HERO_SETTINGS}>
      {HERO_PANELS.map((panel) => (
        <HeroPanelView key={panel.id} panel={panel} />
      ))}
    </Slider>
  </div>
);

export default memo(HeroCarousel);
